import _ from "lodash";
const View = ({ color = "#2E281F", mode = "light", ...props }: any) => {
  let col = "";
  let bg = "";
  const handler: any = {
    light: () => {
      col = color;
      bg = "white";
    },
    dark: () => {
      bg = color;
      col = "white";
    },
  };
  if (_.has(handler, mode)) handler[mode]();
  return (
    <svg {...props} width="49" height="48" viewBox="0 0 49 48" fill="none">
      <g clipPath="url(#clip0_8262_37763)">
        <path
          d="M48.5 24C48.5 10.7438 37.7562 0 24.5 0C11.2438 0 0.5 10.7438 0.5 24C0.5 37.2562 11.2438 48 24.5 48C24.6406 48 24.7812 48 24.9219 47.9906V29.3156H19.7656V23.3063H24.9219V18.8812C24.9219 13.7531 28.0531 10.9594 32.6281 10.9594C34.8219 10.9594 36.7062 11.1188 37.25 11.1938V16.5563H34.1C31.6156 16.5563 31.1281 17.7375 31.1281 19.4719V23.2969H37.0813L36.3031 29.3063H31.1281V47.0719C41.1594 44.1938 48.5 34.9594 48.5 24Z"
          fill={col}
        />
      </g>
      <defs>
        <clipPath id="clip0_8262_37763">
          <rect width="48" height="48" fill={bg} transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default View;
